export const checkAndGetArray = <T>(arrayOrObject: T | T[] | undefined): T[] => {
  if (arrayOrObject) {
    return Array.isArray(arrayOrObject) ? arrayOrObject : [arrayOrObject];
  }
  return [];
};

export const checkAndGetObject = <T>(arrayOrOject: T | T[]): T => {
  return Array.isArray(arrayOrOject) ? arrayOrOject[0] : arrayOrOject;
};

// This was borrowed from https://stackoverflow.com/questions/14446511/most-efficient-method-to-groupby-on-an-array-of-objects
// any is allowed here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const groupBy = (xs, key) => {
  return xs.reduce(function(rv, x) {
    const keyValue = key instanceof Function ? key(x) : key;
    (rv[keyValue] = rv[keyValue] || []).push(x);
    return rv;
  }, {});
};

/**
 * Splits an array into chunks of a certain size.
 * For example, with [1, 2, 3] and a chunk size of 2, should get [[1, 2], [3]]
 *
 * https://medium.com/@Dragonza/four-ways-to-chunk-an-array-e19c889eac4
 *
 * @param array Array to split into chunks
 * @param size Size of each chunk
 */
export function chunk<T extends any>(array: T[], size: number): T[][] {
  const chunkedArray: T[][] = [];

  let index: number = 0;
  while (index < array.length) {
    chunkedArray.push(array.slice(index, size + index));
    index += size;
  }

  return chunkedArray;
}

export function isArrayUndefinedOrEmpty<T extends any>(array?: T[]): boolean {
  return !array || array.length === 0;
}
